import {z} from 'zod';

export const MembershipActionSchema=z.object({requestId:z.uuid(),subscriptionId:z.uuid(),action:z.enum(['cancel','resume','downgrade']),planId:z.uuid().optional()}).strict()
  .refine(value=>value.action==='downgrade'?Boolean(value.planId):value.planId===undefined,{message:'Choose a plan only for a renewal-plan change.'});
export type MembershipAction=z.infer<typeof MembershipActionSchema>;
export const MembershipChangeSchema=z.object({request:MembershipActionSchema,state:z.enum(['pending','review']),requestedAt:z.iso.datetime(),error:z.unknown().nullable()}).strict();
